import { render, staticRenderFns } from "./AtGithubLogin.vue?vue&type=template&id=10b9fb69&"
import script from "./AtGithubLogin.vue?vue&type=script&lang=js&"
export * from "./AtGithubLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports